import AnalysisApi from "../../apis/Analysis";

export default {
  namespaced: true,
  state: {
    analisisArray: [],
    analisisArrayAux: [],
    paginated:{},
    paginatedAux: {},
    file_sales: null,
  },
  mutations: {
    set_analysis(state, data) {
      state.analisisArray = data;
    },
    set_analysis_aux(state, data) {
      state.analisisArrayAux = data;
    },
    set_paginated (state, data) {
      state.paginated =  data
    },
    set_paginated_aux (state, data) {
      state.paginatedAux =  data
    },
    set_file_sales (state, value) {
      state.file_sales = value;
    },
    
  },
  actions: {
    emptyServices({ commit }) {
      commit("set_analysis", []);
    },
    newAnalysis({ commit, dispatch },value){
      commit("set_analysis", value);
    },
    emptyFileSales ({commit}, value) {
      commit('set_file_sales', value);
  },
    async getAnalysis({ commit, dispatch }, filters) {
      return await AnalysisApi.get_allPaginated(filters)
        .then((response) => {
          commit('set_paginated', {
            ...response.data
          })
          commit("set_analysis", response.data.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar servicios, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async getAnalysisAux({ commit, dispatch }, filters) {
      return await AnalysisApi.get_allPaginated(filters)
        .then((response) => {
          commit('set_paginated_aux', {
            ...response.data
          })
          commit("set_analysis_aux", response.data.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar servicios, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async store({ dispatch }, analisis) {
      return await AnalysisApi.store(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getAnalysis");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al registrar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async update({ dispatch }, analisis) {
      return await AnalysisApi.update(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La actualización se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getAnalysis");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al actualizar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, analisis) {
      return await AnalysisApi.delete(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La eliminación se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getAnalysis");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status({ dispatch }, analisis) {
      let action = analisis.active ? "inactivación" : "activación";
      return await AnalysisApi.change_status(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La " + action + " se relizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getAnalysis");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async uploadAnalysisService({ dispatch }, analisis) {
      return await AnalysisApi.uploadAnalysisService(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message:
                "Los reactivos del archivo se registraron de forma correcta.",
            },
            { root: true }
          );
          dispatch("getAnalysis");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message =
            "Ocurrió un error al registrar productos del archivo, vuelva a intentarlo.";
          if (error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async analysisExcel({commit, dispatch}, filters) {
      commit('set_file_sales', null);
      return await AnalysisApi.analysisExcel(filters)
                  .then( response => {
                      commit('set_file_sales', response.data.file_sales);
                  })
                  .catch( error => {
                      if (error.response?.status === 401) return null
                      dispatch('notifications/store_notification', {
                          type: 'error',
                          message: 'Ocurrió un error al descargar reporte de ventas, vuelva a intentarlo.'
                      }, {root: true});
                  })
    },
  },
};
